
import TitleBox from '@/components/CSS/TitleBox'
import { mapGetters } from 'vuex'
import { openServiceAuth, thirdPartyServiceUrl } from '@/settings'

export default {
	components: {
		TitleBox
	},
	computed: {
		...mapGetters({
			userinfo: 'user/userinfo',
			token: 'user/token'
		})
	},
	data() {
		return {
			titleBoxTitle: '我咨询的',
			goodsInfo: null, // 商品信息
			listData: null // 列表信息
		}
	},
	mounted() {
		this.getInfo()
	},
	methods: {
		// 咨询客服
		customerService() {
			if (openServiceAuth && !this.token) {
				this.$message.warning('请先登录')
				this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`)
				return
			}
			let info = {
				action: {
					gameId: this.goodsInfo.gameId,
					goodsCatalogueId: this.goodsInfo.goodsCatalogueId,
					goodsNo: this.goodsInfo.goodsNo
				}
			}
			this.$api.getCustomerService(info).then(res => {
				if (!res.data) {
					this.$message({
						message: '暂无客服值班',
						type: 'error'
					})
					return
				}

				this.$store.dispatch('ry/join', { targetId: res.data.id, conversationType: 1 })
			})
			return
		},
		// 返回
		back() {
			this.$router.go(-1)
		},
		// 获取初始化数据
		getInfo() {
			let _data = {
				goodsNo: this.$route.query.goodsNo
			}
			this.$api.getConsultLabelBuyerInfo(_data).then(res => {
				if (res.success) {
					this.listData = res.data
				} else {
					this.$message.error(res.info)
				}
			})
			this.$api.goodsDetails({ action: { ..._data } }).then(res => {
				if (res.success) {
					this.goodsInfo = res.data
				} else {
					this.$message.error(res.info)
				}
			})
		},
		setSaveUserConsultGoods(id) {
			let p = {
				action: {
					goodsNo: this.goodsInfo.goodsNo,
					goodsCatalogueId: this.goodsInfo.goodsCatalogueId,
					imUserId: id
				}
			}
			this.$api.saveUserConsultGoods(p).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
				}
			})
		}
	}
}
